import { gql, TypedDocumentNode } from '@common/hooks';
import {
  WorksAutocompleteSearchQueryQueryCgResponse,
  WorksAutocompleteSearchQueryQueryVariables,
} from '@common/graphql';
import { AppSearchWorksProfileFragment } from '@institutions/graphql';

export type WorksAutocompleteSearchResponse =
  WorksAutocompleteSearchQueryQueryCgResponse;

export const WORKS_AUTOCOMPLETE_SEARCH_QUERY: TypedDocumentNode<
  WorksAutocompleteSearchQueryQueryCgResponse,
  WorksAutocompleteSearchQueryQueryVariables
> = gql`
  query WorksAutocompleteSearchQuery($searchQuery: String!) {
    worksAutocompleteSearch(searchQuery: $searchQuery) {
      canShowStaffingRequestApplications {
        value
      }
      canShowStaffingRequestAssignments {
        value
      }
      canShowWorksProfiles {
        value
      }
      canShowStaffingRequests {
        value
      }
      canShowWorkers {
        value
      }
      isOrg
      staffingRequests {
        id
        name
        state
        code
      }
      worksProfiles {
        ...AppSearchWorksProfileFragment
      }
      staffingRequestApplications {
        id
        state
        worksProfile {
          ...AppSearchWorksProfileFragment
        }
        staffingRequest {
          id
          code
          name
        }
      }
      staffingRequestAssignments {
        id
        state
        staffingRequestType
        worker {
          id
        }
        worksProfile {
          ...AppSearchWorksProfileFragment
        }
        staffingRequest {
          id
          code
          name
        }
      }
      workers {
        id
        isInternal
        worksUser {
          id
          name
        }
      }
    }
  }
  ${AppSearchWorksProfileFragment}
`;
